import NavBar from './components/navbar/Navbar';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import SportsbookPage from './components/sportsbook/SportsbookPage';
import FantasyPage from './components/fantasy/FantasyPage';
import PrizepicksPage from './components/prizepicks/PrizepicksPage';


function App() {
  return (
  <BrowserRouter>
  <NavBar />
  <Routes>
    <Route path="/fantasy/:id/:type" element={<FantasyPage/>} />
    <Route path="/" element={<SportsbookPage/>} />
    <Route path="/prizepicks" element={<PrizepicksPage/>} />
    <Route path="*" element={<h1>Page Not Found</h1>} />
  </Routes>
  </BrowserRouter>
    
  );
}

export default App;